module.exports = __webpack_public_path__ + "static/media/funitures6.9d293109.svg";